import { SelectInput } from "@/components/InputFields"
import { Organization } from "@/model/Organization"
import cn from "@/utils/cn"
import { ComponentPropsWithRef } from "react"

type OrganizationDropdownProps = {
  organizations: Organization[]
  value: Organization | null
  onChange: (value: Organization | null) => void
} & Omit<
  ComponentPropsWithRef<typeof SelectInput>,
  "value" | "onChange" | "options"
>

const OrganizationDropdown = ({
  organizations,
  value,
  onChange,
  className,
}: OrganizationDropdownProps) => {
  const options: { title: string; value: string; tooltip?: string }[] = [
    { title: "All organizations", value: "all" },
  ].concat(
    [...organizations]
      .sort((a, b) => a.shortName.localeCompare(b.shortName))
      .map((organization) => ({
        title: `${organization.shortName} - ${organization.longName}`,
        value: organization.id,
      }))
  )

  return (
    <div>
      <SelectInput
        value={value?.id ?? "all"}
        options={options}
        className={cn(
          "w-[180px] bg-white text-sm focus:border-slate-300 focus:ring-1 focus:ring-slate-300",
          className
        )}
        onChange={(e) => {
          const organization = organizations.find(
            (organization) => organization.id === e.target.value
          )
          onChange(organization ?? null)
        }}
      />
    </div>
  )
}

export default OrganizationDropdown
